import { EUserRoleActionTypes } from '../../actions/userRole';
import { TUserRole } from '../../types/currentUser';
import { TReduxActions } from '../../types/redux';

const defaultState: TUserRole = null;

export function userRoleReducer(state: TUserRole = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EUserRoleActionTypes.SetUserRole: {
      return action.payload;
    }

    default:
      return state;
  }
}
